import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";
const Reg = () => {
  const ApplicableOption = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  return (
    <div className="card p-3">
      {" "}
      <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3">
        <Accordion.Item eventKey="0">
          <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
            {/* <span className="avatar avatar-md rounded text-dark border me-2">
                    <i className="ti ti-user-plus fs-20" />
                </span> */}
            Shipper
          </Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Name
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Address
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Contact Person
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Telephone
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Email
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion className="accordion-item rounded mb-3">
        <Accordion.Item eventKey="1">
          <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
            {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
            Consignee
          </Accordion.Header>
          <Accordion.Body>
          <div className="row">
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Name
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Address
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Contact Person
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Telephone
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Email
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion className="accordion-item rounded mb-3">
        <Accordion.Item eventKey="1">
          <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
            {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
            Booking Party
          </Accordion.Header>
          <Accordion.Body>
          <div className="row">
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Name
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Address
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Contact Person
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Telephone
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Email
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion className="accordion-item rounded mb-3">
        <Accordion.Item eventKey="1">
          <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
            {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
            Forwarding Agent
          </Accordion.Header>
          <Accordion.Body>
          <div className="row">
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Name
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Address
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Contact Person
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Telephone
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Email
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion className="accordion-item rounded mb-3">
        <Accordion.Item eventKey="1">
          <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
            {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
            Notify
          </Accordion.Header>
          <Accordion.Body>
          <div className="row">
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Name
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Address
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Contact Person
                    </label>
                  </div>
                  <Select
                    className="custom-selector"
                    options={ApplicableOption}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Telephone
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <div className=" mb-1 d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="name"
                      className="form-label mb-0 text-label-red"
                    >
                      Email
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="search_by"
                  />
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <hr />
      <div className="row justify-content-end mt-3 gap-2">
        <button className="btn btn-primary text-xs w-fit" type="submit">
          Save
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit">
          Save & Close
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit">
          Save & New
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit">
          Close
        </button>
      </div>
    </div>
  );
};

export default Reg;
